import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ZtLoaderService {
    loaderSubject = new BehaviorSubject<boolean>(false);

    showLoader() {
        console.log('[ZtLoaderService]: showLoader called. Stack:', new Error().stack?.split('\n')[2]?.trim());
        this.loaderSubject.next(true);
    }

    hideLoader() {
        console.log('[ZtLoaderService]: hideLoader called. Stack:', new Error().stack?.split('\n')[2]?.trim());
        this.loaderSubject.next(false);
    }
}
